import React, { useCallback } from 'react'
import { hooks, I18n } from '@front/volcanion'

import { Button } from '@mui/material'

const ButtonTableActions = props => {
  const selectedIds = props?.table?.selectedIds || []
  const [, { openDialog }] = hooks.useDialogs()

  const openMultiDispatchDialog = useCallback(() => {
    openDialog('multi_dispatch', { formProps: { initialState: { order_ids: selectedIds } } })
  }, [selectedIds, openDialog])

  const disabled = _.isEmpty(selectedIds)

  return (<>
    {!disabled && (
      <Button onClick={openMultiDispatchDialog} size='small' variant='contained'>
        {I18n.t('dispatch.group.label', { count: 1 })}
      </Button>
    )}
  </>
  )
}

export default React.memo(ButtonTableActions)
